export default {
  SET_TOKEN: 'saveToken',

  SET_GUIDE_DATA: 'setGuideData',

  SET_BANK_CARD_DATA: 'setBankCardData',
}
